import React from 'react'
import Cam from './Upload'

const Upload = (props) => (
  <Cam {...props} />
)

export default Upload



// WEBPACK FOOTER //
// ./src/components/Upload/index.js